import PosMenu from './PosMenu';
import SidebarLayout from '../shared/SidebarLayout';

function PosLayout() {
  return (
    <SidebarLayout MenuComponent={PosMenu} />
  );
}

export default PosLayout;
